import {
  AssetDTO,
  BaseEntityDTO,
  IAssetDTO,
  IBaseEntityDTO,
  ICriteriaDTO,
  IYearDTO,
  YearDTO,
} from './';
import { CriteriaDTO } from './criteria.dto';

export interface ICriteriaGroupDTO extends IBaseEntityDTO {
  group_name: string;
  color: string;
  criterias: ICriteriaDTO[];
  year?: IYearDTO;
  description?: string;
  thubmnail?: IAssetDTO;
  sequence: number;
}

export class CriteriaGroupDTO extends BaseEntityDTO implements ICriteriaGroupDTO {
  group_name: string;
  color: string;
  criterias: ICriteriaDTO[];
  year?: IYearDTO;
  description?: string;
  thubmnail?: IAssetDTO;
  sequence: number;

  constructor(data?: Partial<CriteriaGroupDTO>) {
    super(data);
    this.group_name = data?.group_name ?? '';
    this.color = data?.color ?? '';
    this.criterias = data?.criterias ? data.criterias.map((crit) => new CriteriaDTO(crit)) : [];
    this.year = data?.year ? new YearDTO(data?.year) : undefined;
    this.description = data?.description ?? '';
    this.thubmnail = data?.thubmnail ? new AssetDTO(data?.thubmnail) : undefined;
    this.sequence = data?.sequence ?? 0;
  }
}
